export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_05_blank.720e8ed0.png";